// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"425":"545feacf","473":"34998242","557":"61e54aee","741":"e331922e","760":"08220f5f","774":"5ba6f927","782":"857acf6a","787":"ccc468fa","883":"2455038a","943":"40235069"}[chunkId] + ".chunk.js";
};